import styled from 'styled-components'
import { Tag } from '@pinchenterprisesnpm/friday-ui'

export const BadgeItem = styled(Tag)<{ color?: string; border?: string; background?: string }>`
  color: ${({ color, theme: { palette } }) =>
    color ? palette[color as keyof typeof palette] : 'transparent'};
  border: 1px solid
    ${({ color, border, theme: { palette } }) =>
      border && color ? palette[color as keyof typeof palette] : `transparent`};
  border-radius: ${(props) => `${props.theme.mp.sm}`};
  padding: 6px 6px 4px 6px;
  font-weight: ${(props) => props.theme.font.weights.regular};
  text-transform: capitalize;
  background: ${(props) => (props.background ? props.background : `transparent`)};
  margin: ${(props) => `0px ${props.theme.mp.xs} 0px 0px`};

  @media only screen and (min-width: ${(props) => `${props.theme.breakpoints.md}px`}) {
    padding: 3px 8px;
  }
`

export const BadgesCellStyle = styled.div`
  display: flex;
  align-items: center;
  padding: 0px;
  position: static;
  top: auto;
  right: auto;

  > span:hover {
    cursor: default;
  }

  span {
    margin-right: ${(props) => props.theme.mp.xs};
  }
`
